module.exports = __webpack_public_path__ + "img/laptop.e4a26a76.svg";